import { ApolloClient } from '@apollo/client';
import { getApolloClient } from '../../../../../../src/shared/graphql/client';
import { USER_QUERY } from './user.query';
import { FetchUserQuery } from './user.query.generated';
import { logError } from '@zoopla/logger';

export type UserTaxonomy = {
    user_uuid?: string | undefined | null;
    user_id?: number | undefined | null;
    registered?: boolean | undefined | null;
    signed_in_status?: 'signed in' | 'signed out';
    about_me_status?: string | undefined | null;
    registration_platform?: string | undefined | null;
    user_creation_date?: string | undefined | null;
};

export const getUserTaxonomy = async (
    client?: ApolloClient<unknown>
): Promise<UserTaxonomy> => {
    const c = client ?? getApolloClient();
    const {
        data: { user },
        errors
    } = await c.query<FetchUserQuery>({
        // TODO: replace with useIsLoggedIn hook for user state
        query: USER_QUERY
    });

    if (errors) {
        logError(errors);
    }

    return {
        signed_in_status: user?.loggedIn ? 'signed in' : 'signed out',
        about_me_status: user?.senderPropertyStatus,
        registration_platform: user?.registrationSources?.join(', '),
        user_creation_date: user?.creationDate,
        user_id: user?.userId,
        user_uuid: user?.userUuid,
        registered: user?.registered
    };
};
